import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment'
import { Fornecedor } from '../_models/Fornecedor';

@Injectable({
    providedIn: 'root'
})

export class FornecedorService {

    ObterFornecedor(cnpj: string): Observable<any>{
        let apiURL = `${environment.apiUrl}/api/Fornecedor?cnpj=${cnpj}`
        return this.http.get<Fornecedor>(apiURL);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um problema ao verificar aempresa MRV. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
